/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMSIgdmlld0JveD0iMCAwIDE0IDEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcuMzc2MjUgMC4xMjVIMTMuMDAyNVYxSDcuMzc2MjVINi41MDEyNUgwLjg3NVYwLjEyNUg2LjUwMTI1SDcuMzc2MjVaIiBmaWxsPSJibGFjayIvPjwvc3ZnPg==";